import classNames from 'classnames';
import { useCopyTextToClipboard } from 'hooks/useCopyToClipboard';
import type { GridValue } from 'hooks/useCopyToExcel';
import { useCopyToExcel } from 'hooks/useCopyToExcel';
import type { AnalyticCategoryActions, WorkspaceAnalyticCategory } from 'models/analytics';
import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

interface CopyAllButtonByExcelGeneratorProps {
  className?: string;

  excelGrid?: Record<string, GridValue[]> | GridValue[][];
  generateExcelGrid: () => GridValue[][];
  analyticsCategory?: WorkspaceAnalyticCategory;
  analyticsAction?: AnalyticCategoryActions[WorkspaceAnalyticCategory];
}
export const CopyAllButtonByExcelGenerator: FC<CopyAllButtonByExcelGeneratorProps> = ({
  generateExcelGrid,
  analyticsAction,
  analyticsCategory,
  className,
}) => {
  const onCopyToClipboard = useCopyToExcel(generateExcelGrid);
  const onClicked = useCallback(() => {
    if (analyticsCategory && analyticsAction) {
      logAnalytics.trackEvent(analyticsCategory, analyticsAction);
    }
    onCopyToClipboard();
  }, [onCopyToClipboard, analyticsCategory, analyticsAction]);

  return <CopyAllButton className={className} onClick={onClicked} />;
};
interface CopyAllButtonProps {
  className?: string;

  disabled?: boolean;
  onClick?: () => void;

  values?: string[];
}

export const CopyAllButton: FC<CopyAllButtonProps> = ({ onClick, className, disabled, values }) => {
  const formattedValues = useCallback(() => values?.join('\n'), [values]);
  const onCopy = useCopyTextToClipboard();
  return (
    <button
      className={classNames('btn btn-flat-secondary btn-icon-end py-2', className)}
      disabled={disabled}
      onClick={onClick ?? (() => onCopy(formattedValues()))}
    >
      <FormattedMessage id="form.buttons.CopyAll" />
      <i className="icon ps-1">file_copy</i>
    </button>
  );
};
